import {
  COURSE_TYPES,
  EVENT_TYPES,
  INTERVIEW_TAG_TYPES,
  OP_TYPES,
  SERVICE_AUDIT_TYPE,
  SERVICE_STATUS_TYPES,
  TAG_TYPES,
  VM_TYPES,
} from './constants'
import translateApi from '@/api/translate'

/**
 * 计算 UTF-8 编码字符串长度
 * @param inputStr
 * @returns {number}
 */
export const counterStrLength = function (inputStr) {
  let totalLength = 0
  /* 计算utf-8编码情况下的字符串长度 */
  for (let i = 0; i < inputStr.length; i++) {
    if (inputStr.charCodeAt(i) <= parseInt('0x7F')) {
      totalLength += 1
    } else if (inputStr.charCodeAt(i) <= parseInt('0x7FF')) {
      totalLength += 2
    } else if (inputStr.charCodeAt(i) <= parseInt('0xFFFF')) {
      totalLength += 3
    } else if (inputStr.charCodeAt(i) <= parseInt('0x1FFFFF')) {
      totalLength += 4
    } else if (inputStr.charCodeAt(i) <= parseInt('0x3FFFFFF')) {
      totalLength += 5
    } else {
      totalLength += 6
    }
  }
  return totalLength
}

/**
 * 将src对象属性copy到dist对象中
 * @param src
 * @param dist
 */
export const copyObject = function (src, dist) {
  for (const k in src) {
    // eslint-disable-next-line no-prototype-builtins
    if (dist.hasOwnProperty(k)) {
      dist[k] = src[k]
    }
  }
}

/**
 * 格式化时间
 *
 * @param fmt
 * @param date
 * @returns {*}
 */
export const dateFormat = function (fmt, date) {
  let ret
  const opt = {
    'Y+': date.getFullYear().toString(),
    'm+': (date.getMonth() + 1).toString(),
    'd+': date.getDate().toString(),
    'H+': date.getHours().toString(),
    'M+': date.getMinutes().toString(),
    'S+': date.getSeconds().toString(),
  }
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
    }
  }
  return fmt
}

export const formatTime = function (time) {
  if (time === 0) {
    return '-'
  }
  if (time / 10000000000 < 1) {
    time = time * 1000
  }
  return dateFormat('YYYY-mm-dd HH:MM', new Date(time))
}
export const getZoneTime = function (date, zone) {
  if (!date || !zone || date === '') {
    return ''
  }
  const targetDate = new Date(date + date.getTimezoneOffset() * 60 * 1000 + zone * 60 * 60 * 1000)
  return targetDate.getTime()
}

/**
 * 将日期格式转换成时间戳
 *
 * @param date
 * @returns {number}
 */
export const parseDate = function (date) {
  return Date.parse(date) / 1000
}

/**
 * 通过标签名拿标签ID
 *
 * @param allTag
 * @param tagNames
 * @returns {*[]}
 */
export const getTagIds = function (allTag, tagNames) {
  const allTagMap = {}
  for (let i = 0; i < allTag.length; i++) {
    allTagMap[allTag[i].name] = allTag[i].id
  }
  const tagIds = []
  for (let i = 0; i < tagNames.length; i++) {
    // eslint-disable-next-line no-prototype-builtins
    if (allTagMap.hasOwnProperty(tagNames[i])) {
      tagIds.push(allTagMap[tagNames[i]])
    }
  }
  return tagIds
}

export const computeServiceStatus = function (status) {
  const data = {
    color: 'info',
  }
  SERVICE_STATUS_TYPES.map((item) => {
    if (status === item.CODE) {
      data.text = item.TEXT
    }
  })
  return data
}

export const computeAuditStatus = function (status) {
  const data = {
    color: 'info',
  }
  SERVICE_AUDIT_TYPE.map((item) => {
    if (status === item.CODE) {
      data.text = item.TEXT
    }
  })
  return data
}

export const computeServiceType = function (courseType) {
  const data = {
    color: 'info',
  }
  COURSE_TYPES.map(item => {
    if (courseType === item.CODE) {
      data.text = item.TEXT
    }
  })
  return data
}

export const computeTagType = function (tagType) {
  const data = {
    color: 'info',
  }
  TAG_TYPES.map(item => {
    if (tagType === item.CODE) {
      data.text = item.TEXT
    }
  })
  INTERVIEW_TAG_TYPES.map(item => {
    if (tagType === item.CODE) {
      data.text = item.TEXT
    }
  })
  return data
}

export const computeEventType = function (eventType) {
  const data = {}
  EVENT_TYPES.map(item => {
    if (eventType === item.CODE) {
      data.text = item.TEXT
    }
  })
  return data
}
export const computeOpType = function (opType) {
  const data = {}
  OP_TYPES.map(item => {
    if (opType === item.CODE) {
      data.text = item.TEXT
    }
  })
  return data
}
export const computeVmType = function (vmType) {
  const data = {}
  VM_TYPES.map(item => {
    if (vmType === item.CODE) {
      data.text = item.TEXT
    }
  })
  return data
}
export const translateData = async function (text) {
  let res = ''
  const params = {
    text: text.replace('•', '^$^$^$^$'),
    targetLanguage: 'en',
  }
  await translateApi.translateText(params).then(response => {
    res = response.translatedText.replace('^$^$^$^$', '•')
  }).catch(error => {
    this.showToast(error.msg, {
      duration: 1000,
      icon: 'fa-warning',
      position: 'top-center',
      fullWidth: false,
    })
  })
  return res
}
